import { useState, useEffect } from 'react';
import axios from 'axios';
import lscache from 'lscache';
//
const useFetch = (url, useCache = false) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const res = await axios.get(url);
      setResponse(res);
      if (useCache) {
        setCache(res);
      }
    } catch (errorMessage) {
      console.log('use-fetch error:', errorMessage);
      setError(errorMessage);
    }
  };

  const getKey = (id) => {
    return `ig_${id}`;
  };

  const setCache = (data) => {
    lscache.set(getKey(url), data, 60);
  };

  const getCache = () => {
    return lscache.get(getKey(url));
  };

  useEffect(() => {
    if (useCache) {
      const cachedData = getCache();

      if (cachedData) {
        setResponse(cachedData);
      } else {
        fetchData();
      }
    } else {
      fetchData();
    }
  }, [url]);

  return { response, error };
};
export { useFetch };
